import(/* webpackMode: "eager", webpackExports: ["LoginPanel"] */ "/workspace/src/components/auth/auth-panels.tsx");
